import React from 'react';
import Button from '../../../components/ui/Button';

const FilterChips = ({ activeFilters, onFilterChange, eventCount = 0 }) => {
  const categories = [
    { id: 'all', label: 'All Events' },
    { id: 'music', label: 'Music' },
    { id: 'sports', label: 'Sports' },
    { id: 'theater', label: 'Theater' },
    { id: 'comedy', label: 'Comedy' },
    { id: 'food', label: 'Food & Drink' },
    { id: 'art', label: 'Art & Culture' }
  ];

  const dateFilters = [
    { id: 'today', label: 'Today' },
    { id: 'tomorrow', label: 'Tomorrow' },
    { id: 'weekend', label: 'This Weekend' },
    { id: 'week', label: 'This Week' },
    { id: 'month', label: 'This Month' }
  ];

  const priceFilters = [
    { id: 'free', label: 'Free' },
    { id: 'under25', label: 'Under $25' },
    { id: 'under50', label: 'Under $50' },
    { id: 'under100', label: 'Under $100' }
  ];

  const handleFilterClick = (filterId, filterType) => {
    onFilterChange(filterId, filterType);
  };

  return (
    <div className="space-y-4 mb-6">
      {/* Categories */}
      <div>
        <h3 className="text-sm font-medium text-foreground mb-2">Categories</h3>
        <div className="flex flex-wrap gap-2">
          {categories?.map((category) => (
            <Button
              key={category?.id}
              variant={activeFilters?.category === category?.id ? 'default' : 'outline'}
              size="sm"
              onClick={() => handleFilterClick(category?.id, 'category')}
              className="text-xs"
            >
              {category?.label}
            </Button>
          ))}
        </div>
      </div>
      {/* Date Filters */}
      <div>
        <h3 className="text-sm font-medium text-foreground mb-2">When</h3>
        <div className="flex flex-wrap gap-2">
          {dateFilters?.map((filter) => (
            <Button
              key={filter?.id}
              variant={activeFilters?.date === filter?.id ? 'default' : 'outline'}
              size="sm"
              onClick={() => handleFilterClick(filter?.id, 'date')}
              className="text-xs"
            >
              {filter?.label}
            </Button>
          ))}
        </div>
      </div>
      {/* Price Filters */}
      <div>
        <h3 className="text-sm font-medium text-foreground mb-2">Price</h3>
        <div className="flex flex-wrap gap-2">
          {priceFilters?.map((filter) => (
            <Button
              key={filter?.id}
              variant={activeFilters?.price === filter?.id ? 'default' : 'outline'}
              size="sm"
              onClick={() => handleFilterClick(filter?.id, 'price')}
              className="text-xs"
            >
              {filter?.label}
            </Button>
          ))}
        </div>
      </div>
      {/* Results Count */}
      <div className="flex items-center justify-between pt-2 border-t border-border">
        <span className="text-sm text-muted-foreground">
          {eventCount} events found
        </span>
        {(activeFilters?.category !== 'all' || activeFilters?.date || activeFilters?.price) && (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange('all', 'reset')}
            className="text-xs"
          >
            Clear filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterChips;